import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_IMG = "/images/hero.webp";

export const Hero = () => (
  <section className="relative min-h-screen flex items-center pt-24 grain overflow-hidden" data-testid="hero-section">
    <div className="max-w-7xl mx-auto px-6 py-24 grid lg:grid-cols-2 gap-16 items-center w-full">
      <div className="fade-up">
        <div className="barbersign inline-flex items-center gap-5 px-10 py-6 mb-10" data-testid="hero-sign">
          <img src="/images/logo-mark.png" alt="The hat, the beard, the quiet halo" className="h-24 w-auto" />
          <span className="font-sign gilded-sign text-5xl sm:text-6xl tracking-[0.14em] uppercase leading-none">No BS<br />Counselling</span>
        </div>
        <p className="eyebrow mb-8">Counselling · The Coast · Back from Sabbatical</p>
        <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.15] text-hearth-ink" data-testid="hero-headline">
          No BS. Means exactly what it says.
        </h1>
        <p className="mt-8 font-display font-bold text-xl sm:text-2xl text-hearth-ochre leading-snug max-w-lg">
          No Boring Sessions. No Blame Shifting. No Bad Surprises. No Silver Bullet. No Shrink Speak.
        </p>
        <p className="mt-4 font-essay italic text-xl text-hearth-muted">
          (No Brave Face needed. Yeah. That too.)
        </p>
        <p className="mt-10 font-display font-bold text-2xl sm:text-3xl text-hearth-ink">
          You found this page. Hardest part's done.
        </p>
        <p className="mt-4 font-essay italic text-xl text-hearth-muted max-w-lg">
          (For the blokes, that last part was a lie. You're doing it anyway - on ya mate.)
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link
            to="/book"
            data-testid="hero-book-button"
            className="inline-flex items-center gap-3 bg-hearth-ember hover:bg-hearth-ochre hover:text-hearth-bg text-hearth-ink font-semibold text-sm tracking-widest uppercase px-8 py-4 transition-colors"
          >
            Book a Session <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            to="/story"
            data-testid="hero-story-button"
            className="inline-flex items-center gap-3 border border-hearth-line hover:border-hearth-ochre text-hearth-muted hover:text-hearth-ink font-semibold text-sm tracking-widest uppercase px-8 py-4 transition-colors"
          >
            Read the Story
          </Link>
        </div>
        <p className="mt-10 font-essay italic text-hearth-ochre text-xl">"Trauma is a chapter, not the title."</p>
      </div>
      <div className="relative fade-up hidden lg:block" style={{ animationDelay: "0.25s" }}>
        <div className="deco-frame">
          <img
            src={HERO_IMG}
            alt="Matt from behind — leather farmer's hat, plaid shirt"
            className="w-full h-[560px] object-cover object-top grayscale-[35%] contrast-110"
            data-testid="hero-image"
          />
        </div>
        <div className="absolute -bottom-6 -left-6 bg-hearth-surface border border-hearth-line px-8 py-6">
          <p className="font-display text-3xl text-hearth-ink">Safe. Approachable.</p>
          <p className="font-display text-3xl text-hearth-ember">Unshockable.</p>
        </div>
      </div>
    </div>
  </section>
);
